import { CONTACT_METHOD_LABELS, createEmptyContactMethod } from '../utils/contactMethods';

export default function ContactMethodsEditor({
  value,
  onChange,
  disabled = false,
  idPrefix = 'contact-method',
}) {
  const methods = Array.isArray(value) && value.length > 0
    ? value
    : [createEmptyContactMethod()];
  const labelListId = `${idPrefix}-labels`;

  const updateMethods = (nextMethods) => {
    const primaryIndex = nextMethods.findIndex((method) => method.isPrimary === true);
    const safeMethods = nextMethods.map((method, index) => ({
      ...method,
      isPrimary: primaryIndex >= 0 ? index === primaryIndex : index === 0,
    }));

    onChange(safeMethods);
  };

  const handleFieldChange = (methodId, field, fieldValue) => {
    updateMethods(
      methods.map((method) =>
        method.id === methodId
          ? {
            ...method,
            [field]: field === 'hasWhatsapp' ? Boolean(fieldValue) : fieldValue,
          }
          : method
      )
    );
  };

  const handleSetPrimary = (methodId) => {
    updateMethods(
      methods.map((method) => ({
        ...method,
        isPrimary: method.id === methodId,
      }))
    );
  };

  const handleAddMethod = () => {
    updateMethods([
      ...methods,
      createEmptyContactMethod({
        label: 'Other',
        isPrimary: methods.length === 0,
      }),
    ]);
  };

  const handleDeleteMethod = (methodId) => {
    if (methods.length <= 1) {
      return;
    }

    updateMethods(methods.filter((method) => method.id !== methodId));
  };

  return (
    <fieldset className="form-section contact-methods-editor">
      <legend>Contact Methods</legend>
      <datalist id={labelListId}>
        {CONTACT_METHOD_LABELS.map((label) => (
          <option key={label} value={label} />
        ))}
      </datalist>

      <div className="contact-methods-editor__rows">
        {methods.map((method, index) => (
          <div className="contact-method-row" key={method.id || `method-${index}`}>
            <div className="contact-method-row__header">
              <h4>Contact Method #{index + 1}</h4>
              <button
                type="button"
                className="btn btn-secondary contact-method-row__delete"
                onClick={() => handleDeleteMethod(method.id)}
                disabled={disabled || methods.length <= 1}
              >
                Delete
              </button>
            </div>

            <div className="contact-method-row__body">
              <label>
                <span>Label</span>
                <input
                  type="text"
                  list={labelListId}
                  value={method.label || ''}
                  onChange={(event) =>
                    handleFieldChange(method.id, 'label', event.target.value)
                  }
                  disabled={disabled}
                />
              </label>

              <label>
                <span>Number *</span>
                <input
                  type="tel"
                  value={method.number || ''}
                  onChange={(event) =>
                    handleFieldChange(method.id, 'number', event.target.value)
                  }
                  required
                  disabled={disabled}
                />
              </label>
            </div>

            <div className="contact-method-row__toggles">
              <label className="checkbox-field">
                <input
                  type="checkbox"
                  checked={method.hasWhatsapp === true}
                  onChange={(event) =>
                    handleFieldChange(method.id, 'hasWhatsapp', event.target.checked)
                  }
                  disabled={disabled}
                />
                <span>Has WhatsApp</span>
              </label>

              <label className="checkbox-field">
                <input
                  type="radio"
                  name={`${idPrefix}-primary`}
                  checked={method.isPrimary === true}
                  onChange={() => handleSetPrimary(method.id)}
                  disabled={disabled}
                />
                <span>Primary</span>
              </label>
            </div>
          </div>
        ))}
      </div>

      <button
        type="button"
        className="btn btn-secondary"
        onClick={handleAddMethod}
        disabled={disabled}
      >
        Add Contact Method
      </button>
    </fieldset>
  );
}
